import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getLicenseTypes() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/global?type=LicenseTypes'
      }))
  );
}

export default {
  getLicenseTypes,
};
